angular.module('unica_approvation_list.approvation_list_controllers')

.controller('ApprovationListViewAmController',
	function(
		$rootScope, $scope, $state, $stateParams,
		CONFIG,
		InvitationListService,
		ApprovationListListService, ApprovationListEditService,
		$confirm
	) {

	$scope.invitation_list_id = $stateParams.invitation_list_id;
	$scope.event_id           = $stateParams.event_id;

	$rootScope.getInvitationList( $stateParams.invitation_list_id );

	$scope.invitations = [];

	$rootScope.getApprovationList($stateParams.id);

	$scope.loadInvitations = function() {
		$scope.showLoader();

		InvitationListService
			.fullList( $rootScope.invitationListData.id, $stateParams.id )
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.invitations = $scope.invitations.concat( data );
				} else {
					$rootScope.manageError(data);
				}
			});
	};

	$scope.$on( 'invitation_list_loaded', function() {
		$scope.loadInvitations();
	});

	$scope.confirmList = function() {

		$confirm({
			title: 'Sei sicuro di voler confermare la lista?',
			text: 'Confermi la lista per l\'approvazione?'
		}).then(function() {

			$scope.showLoader();
			ApprovationListEditService
				.updateStatus( $rootScope.approvationListData.id, 'confirmed')
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						$rootScope.approvationListData.status = 'confirmed';
						$scope.showSuccessMsg('Lista approvata con successo!', '');
					} else {
						$rootScope.manageError(data);
					}
				});

		}, function() {
			// Cancel
		});

	};

	$scope.denyList = function() {

		$confirm({
			title: 'Sei sicuro di voler rifiutare la lista?',
			text: 'Rifiuti la lista per l\'approvazione?'
		}).then(function() {

			$scope.showLoader();
			ApprovationListEditService
				.updateStatus( $rootScope.approvationListData.id, 'rejected')
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						$rootScope.approvationListData.status = 'rejected';
						$scope.showSuccessMsg('Lista rifiutata con successo!', '');
					} else {
						$rootScope.manageError(data);
					}
				});

		}, function() {
			// Cancel
		});

	};


	$scope.downloadExportSelected = false;
	$scope.exportSelectedUrl      = '';

	$scope.prepareExportSelectedUrl = function() {
		$scope.showLoader();
		ApprovationListListService
			.exportList( $stateParams.id )
			.then(function(url) {
				$scope.hideLoader();

				if ( url ) {
					$scope.downloadExportSelected = true;
					$scope.exportSelectedUrl      = url;
				}
			});
	};

});
